import { setLayoutDefaults } from '@2/layout/layout-store'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useEffect } from 'react'
import ErrorComponent from '../../Components/ErrorComponent'
import LoadingSpinner from '../../Components/LoadingSpinner'
import PageBody from '../../Pages/Layout/PageBody'
import OverheadExpenseListPage from '../../Pages/OverheadExpenseListPage/OverheadExpenseListPage'
import OverheadExpenseListPageHeader from '../../Pages/OverheadExpenseListPage/OverheadExpenseListPageHeader'
import PermissionDenied from '../../Pages/PermissionDenied'
import { processTRPCData } from '../../Queries/fetchData'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import { operationalExpensesStore } from '../../version2/pages/overhead-expenses/overhead-expenses-store'
import { OverHeadExpensePage as OverHeadExpensePageV2 } from '../../version2/pages/overhead-expenses/overhead-expenses-page'
import { PageBody as V2PageBody } from '@2/layout/page-body'
import { trpc } from '../../system/trpc'

export const Route = createFileRoute('/_private/overhead-expenses')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'overheadExpenses', params))
            throw new Error('Permission Denied')
        setLayoutDefaults({
            pageTitle: 'Operational Expenses',
            subMenu: 'organisation',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async () => await loader(),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
})

const loader = async () => {
    if (migratedToV2()) {
        setIsLoading(true)
        try {
            const result =
                await trpc.operationalExpense.getOperationalExpenses.query()

            if (result.operationalExpenses) {
                // Parse dates from the API response
                const parsedOperationalExpenses =
                    result.operationalExpenses.map((operationalExpense) => ({
                        ...operationalExpense,
                        value: operationalExpense.value
                            ? Number(operationalExpense.value)
                            : null,
                        startDate: operationalExpense.startDate
                            ? new Date(operationalExpense.startDate)
                            : null,
                        endDate: operationalExpense.endDate
                            ? new Date(operationalExpense.endDate)
                            : null,
                    }))

                setOperationalExpenses(parsedOperationalExpenses)
                setPendingChanges(false)
            }

            return result
        } catch (error) {
            console.error('Error loading overhead expense:', error)
            throw error
        } finally {
            setIsLoading(false)
        }
    }
    const data = await trpc.legacy.getOverheadExpensesPageData.query()
    return processTRPCData(data)
}

function Wrapper() {
    // The store now handles all the save toast logic internally
    operationalExpensesStore.useSaveHandler()

    if (migratedToV2()) {
        return (
            <V2PageBody>
                <OverHeadExpensePageV2 />
            </V2PageBody>
        )
    }

    return (
        <>
            <OverheadExpenseListPageHeader />
            <PageBody>
                <OverheadExpenseListPage />
            </PageBody>
        </>
    )
}
